import $ from 'jquery';

export default function readCourseAndLavelFromTable() {
        //Der mutationObserver prüft, ob im Dom etwas geändert worden ist
        let mutationObserver = new MutationObserver(function(mutations) {
                mutations.forEach(function(mutation) {
                        // Wenn die Änderunegn (durch Filter oder Pagination) die Tabelle betreffen (Desktop-Ansicht),
                        // wird ein Counter hochgezählt
                        // Die Änderung des Counters wird ebenfalls überwacht
                        // Ändert sich der Counter so läuft nochmal das Skript zum Ermittlung der Niveaus und Kurse
                        if ($(".ws-table").length > 0){
                                /*if(mutation.previousSibling != null) {
                                        console.log("Hallo");
                                        if(mutation.previousSibling.classList.contains("ws-data-row") == true) {
                                                let changeCounter = parseInt($(".change_counter").text());
                                                let change = changeCounter + 1;
                                                $(".change_counter").text(change);
                                        }
                                }*/
                                if (mutation.addedNodes != null) {
                                        mutation.addedNodes.forEach(function (an) {
                                                if (an.classList != null) {
                                                        if (an.classList.contains("ws-data-row") === true) {
                                                                let changeCounter = parseInt($(".change_counter").text());
                                                                let change = changeCounter + 1;
                                                                $(".change_counter").text(change);
                                                        }
                                                }
                                        });
                                }




                        }
                        // Wenn man sich von der Mobile-Ansicht nach der Desktop-Ansicht bewegt,
                        // wird ein Counter hochgezählt
                        // Die Änderung des Counters wird ebenfalls überwacht
                        // Ändert sich der Counter so läuft nochmal das Skript zum Ermittlung der Niveaus und Kurse
                        if (mutation.addedNodes != null) {
                                mutation.addedNodes.forEach(function (an) {
                                        if (an.classList != null) {
                                                if (an.classList.contains("ws-table") === true){
                                                        let changeCounter = parseInt($(".change_counter").text());
                                                        let change = changeCounter + 1;
                                                        $(".change_counter").text(change);
                                                }
                                        }
                                });
                        }
                        // Überwachung Mobile-Ansicht
                        if ($(".ws-course-accordion").length > 0){
                                // Wenn man sich von der Desktop-Ansicht  nach  der Mobile-Ansicht bewegt,
                                // wird ein Counter hochgezählt
                                // Die Änderung des Counters wird ebenfalls überwacht
                                // Ändert sich der Counter so läuft nochmal das Skript zum Ermittlung der Niveaus und Kurse
                                if (mutation.removedNodes != null) {
                                        mutation.removedNodes.forEach(function (rn) {
                                                if (rn.classList != null) {
                                                        if ((rn.classList.contains("ws-table") === true) || (rn.classList.contains("sc-jrAGrp") === true)){
                                                                let changeCounter = parseInt($(".change_counter").text());
                                                                let change = changeCounter + 1;
                                                                $(".change_counter").text(change);
                                                        }
                                                }
                                        });
                                }
                                // Wenn die Änderunegn (durch Filter oder Pagination) die Accordions betreffen (Mobile-Ansicht),
                                // wird ein Counter hochgezählt
                                // Die Änderung des Counters wird ebenfalls überwacht
                                // Ändert sich der Counter so läuft nochmal das Skript zum Ermittlung der Niveaus und Kurse
                                if (mutation.addedNodes != null) {
                                        mutation.addedNodes.forEach(function (an) {
                                                if (an.classList != null) {
                                                        if (an.classList.contains("ws-accordion-pane") === true){
                                                                let changeCounter = parseInt($(".change_counter").text());
                                                                let change = changeCounter + 1;
                                                                $(".change_counter").text(change);
                                                        }
                                                }
                                        });
                                }
                        }
                });
        });
        mutationObserver.observe(document.documentElement, {
                attributes: true,
                characterData: true,
                childList: true,
                subtree: true,
                attributeOldValue: true,
                characterDataOldValue: true
        });


        // Überwachung des Counters
        // Der Counter wird hochgezählt, wenn eine Änderung der Tabelle (Desktop-Ansicht)
        // oder der Accordions (Mobile-Ansicht) vorkommen.
        // die Änderungen sind:
        // 1. Laden der Seite
        // 2. Laden der Seite aufgrund der Nuntzung von Filter
        // 3. Laden der Seite aufgrund der Nunzung von Pagination
        // 4. Bewegung zwischen Mobile- und Desktop-Ansicht und umgekehrt
        let target = document.querySelector('.change_counter');
        if (target != null) {
                let observer = new MutationObserver(function(mutations) {
                        if ($(".ws-table").length > 0) {
                                let i = 0;
                                $(".ws-data-row").each(function (){
                                        let row = this.id;
                                        let level1 = "";
                                        let level2 = "";
                                        let levelCheck = "";
                                        let individual = "";
                                        let examLevel = "";
                                        let levelDescription1 = "";
                                        let levelDescription2 = "";
                                        let levelComplete = "";
                                        let levelCompleteString = "";
                                        levelCompleteString = $(this).find('.ws-course-cell > .ws-cell-span').text();
                                        if (levelCompleteString != "") {
                                                let words = levelCompleteString.split(' ');
                                                if (words.length > 0) {
                                                        levelDescription1 = "<span class='course course_type1'>"+ words[0] +"</span>";
                                                }
                                                if (words.length >= 1) {
                                                        if (words[1] == "A1") {
                                                                level1 = "<span class='level level_a1'>" + words[1] + "</span>";
                                                        }
                                                        if (words[1] == "A2") {
                                                                level1 = "<span class='level level_a2'>" + words[1] + "</span>";
                                                        }
                                                        if (words[1] == "B1") {
                                                                level1 = "<span class='level level_b1'>" + words[1] + "</span>";
                                                        }
                                                        if (words[1] == "B2") {
                                                                level1 = "<span class='level level_b2'>" + words[1] + "</span>";
                                                        }
                                                        if (words[1] == "C1") {
                                                                level1 = "<span class='level level_c1'>" + words[1] + "</span>";
                                                        }
                                                        if (words[1] == "C2") {
                                                                level1 = "<span class='level level_c2'>" + words[1] + "</span>";
                                                        }
                                                }
                                                if (words.length >= 2) {
                                                        if (words[2] == "A1") {
                                                                level2 = "<span class='level level_a1'>" + words[2] + "</span>";
                                                        }
                                                        if (words[2] == "A2") {
                                                                level2 = "<span class='level level_a2'>" + words[2] + "</span>";
                                                        }
                                                        if (words[2] == "B1") {
                                                                level2 = "<span class='level level_b1'>" + words[2] + "</span>";
                                                        }
                                                        if (words[2] == "B2") {
                                                                level2 = "<span class='level level_b2'>" + words[2] + "</span>";
                                                        }
                                                        if (words[2] == "C1") {
                                                                level2 = "<span class='level level_c1'>" + words[2] + "</span>";
                                                        }
                                                        if (words[2] == "C2") {
                                                                level2 = "<span class='level level_c2'>" + words[2] + "</span>";
                                                        }
                                                }
                                                if (words.length >= 3) {
                                                        if (words[3] != "Auffrischungskurs") {
                                                                levelDescription2 = "<span class='course course_type2'>" + words[3] + "</span>";
                                                        }
                                                        if (words[3] == "Auffrischungskurs") {
                                                                level2 = "";
                                                        }

                                                }
                                                if ((level2 != "") || (levelDescription2 != "")) {
                                                        if ((words[3] == "telc") && (words[2] != words[3])) {
                                                                levelComplete = level1 + " " + level2 + " " + levelDescription1 + " " + levelDescription2 + "<br>";
                                                        }
                                                        else {
                                                                levelComplete = level1 + " " + levelDescription1 + "<br>" + level2 + " " + levelDescription2 + "<br>";
                                                        }

                                                }
                                                else {
                                                        levelComplete = level1 + " " + levelDescription1 + "<br>";
                                                }
                                                if (levelCompleteString.includes("Individualkurs") == true) {
                                                        individual = "<span class='individual'>Individualkurs</span>";
                                                        levelComplete = "";
                                                }
                                                if ($(this).find('.ws-info-cell > .individual').length == 0) {
                                                        if(individual  != "") {
                                                                $(this).find('.ws-info-cell').prepend(individual);
                                                        }
                                                }
                                                if ($(this).find('.ws-info-cell > .level').length == 0) {
                                                        if(levelComplete != "") {
                                                                $(this).find('.ws-info-cell').prepend(levelComplete);
                                                        }
                                                }

                                                i++;
                                                if(i == $(".ws-data-row").length) {
                                                        $(".ws-table").addClass("show_table");
                                                }
                                                let toDate= $(this).find('.ws-to-cell > .ws-cell-span').text();
                                                if (toDate == "") {
                                                        $(this).find('.ws-from-cell').addClass("from-and-to-cell");
                                                }
                                        }
                                        else {
                                                examLevel = $(this).find('.ws-info-cell > .ws-cell-span').text();
                                                if (examLevel.includes("Prüfung telc")) {
                                                        levelDescription1 = "<span class='course course_type1'>Prüfung telc</span>";
                                                }
                                                if (examLevel.includes("A1")) {
                                                        level1 = level1 + "<span class='level level_a1'>A1</span>" + "<span> </span>";
                                                }
                                                if (examLevel.includes("A2")) {
                                                        level1 = level1 + "<span class='level level_a2'>A2</span>" + "<span> </span>";
                                                }
                                                if (examLevel.includes("B1")) {
                                                        level1 = level1 + "<span class='level level_b1'>B1</span>" + "<span> </span>";
                                                }
                                                if (examLevel.includes("B2")) {
                                                        level1 = level1 + "<span class='level level_b2'>B2</span>" + " ";
                                                }
                                                if (examLevel.includes("C1")) {
                                                        level1 = level1  + "<span class='level level_c1'>C1</span>"+ "<span> </span>";
                                                }
                                                if (examLevel.includes("C2")) {
                                                        level1 = level1 + "<span class='level level_c2'>C2</span>" + "<span> </span>";
                                                }
                                                if ((level1 != "") || (levelDescription1 != "")) {
                                                        levelComplete = level1 + " " + levelDescription1 + "<br>";
                                                }
                                                if(levelComplete != "") {
                                                        $(this).find('.ws-info-cell').prepend(levelComplete);
                                                }
                                                let toDate= $(this).find('.ws-to-cell > .ws-cell-span').text();
                                                if (toDate == "") {
                                                        $(this).find('.ws-from-cell').addClass("from-and-to-cell");
                                                }
                                        }

                                })
                                //let headTime = "<th class='data'>Zeitraum</th>"
                                //$("th.ws-from-cell").after(headTime);
                                $(".ws-booklink-cell > a").text("Jetzt buchen");
                                setTimeout(function () {
                                        $(".ws-booklink-cell").addClass("show-data");
                                }, 1000);
                                $("th.ws-from-cell").text("Zeitraum");
                                $("th.ws-from-cell").addClass("show-data");
                                $("th.ws-info-cell").text("Veranstaltung");
                                $("th.ws-info-cell").addClass("show-information");
                                $(".ws-course-individualkurs > .ws-from-cell").addClass("individual-not-show");
                                $(".ws-course-individualkurs > .ws-to-cell").addClass("individual-not-show");
                        }
                        if ($(".ws-course-accordion").length > 0) {
                               $(".ws-accordion-header > .ws-accordion-title").each(function (){
                                       let course1 = $(this).find('.course1');
                                       let course2 = $(this).find('.course2');
                                       let course2text = $(this).find('.course2').text();
                                       course2.after(course1);
                                       if (course2text == "A1") {
                                               course2.addClass("level_a1");
                                       }
                                       if (course2text == "A2") {
                                               course2.addClass("level_a2");
                                       }
                                       if (course2text == "B1") {
                                               course2.addClass("level_b1");
                                       }
                                       if (course2text == "B2") {
                                               course2.addClass("level_b2");
                                       }
                                       if (course2text == "C1") {
                                               course2.addClass("level_c1");
                                       }
                                       if (course2text == "C2") {
                                               course2.addClass("level_c2");
                                       }
                               });
                        }
                });

                observer.observe(target, {
                        attributes:    true,
                        childList:     true,
                        characterData: true
                });
        }

        // Beim Laden der Seite wird geprüft, ob die Tabelle oder die Accordions vorhanden sind
        // ist dies der Fall, so wird der Counter hochgezählt
        window.onload = function () {
                let timeleft = 1000;
                let uploadTableTimer = setInterval(function () {
                        if ($(".ws-table").length > 0) {
                                timeleft = 0;
                                let changeCounter = parseInt($(".change_counter").text());
                                if (changeCounter == 0) {
                                        let change = changeCounter + 1;
                                        $(".change_counter").text(change);
                                }

                        }
                        else if ($(".ws-course-accordion").length > 0) {
                                let changeCounter = parseInt($(".change_counter").text());
                                if (changeCounter == 0) {
                                        let change = changeCounter + 1;
                                        $(".change_counter").text(change);
                                }
                        }
                        else {
                                timeleft = 1000;
                        }
                        if (timeleft <= 0) {
                                clearInterval(uploadTableTimer);
                        }
                }, timeleft);
        }


}